import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from '@/pages/HomePage';
import { EnvironmentsPage } from '@/pages/EnvironmentsPage';
import { EnvironmentDetailPage } from '@/pages/EnvironmentDetailPage';
import { CreateEnvironmentPage } from '@/pages/CreateEnvironmentPage';
import { DatabasesPage } from '@/pages/DatabasesPage';
import { CreateDatabasePage } from '@/pages/CreateDatabasePage';
import { DatabaseDetailPage } from '@/pages/DatabaseDetailPage';
import { ApiKeysPage } from '@/pages/ApiKeysPage';
import { AdminQueuePage } from '@/pages/AdminQueuePage';
import { AdminStatsPage } from '@/pages/AdminStatsPage';
import { AdminReconcilePage } from '@/pages/AdminReconcilePage';
import { Layout } from '@/components/Layout';
import { ProtectedRoute } from '@/components/ProtectedRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />
        
        {/* Protected routes with layout */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/environments" element={<EnvironmentsPage />} />
          <Route path="/environments/create" element={<CreateEnvironmentPage />} />
          <Route path="/environments/:id" element={<EnvironmentDetailPage />} />
          <Route path="/databases" element={<DatabasesPage />} />
          <Route path="/databases/create" element={<CreateDatabasePage />} />
          <Route path="/databases/:id" element={<DatabaseDetailPage />} />
          <Route path="/api-keys" element={<ApiKeysPage />} />
          <Route path="/admin/queue" element={<AdminQueuePage />} />
          <Route path="/admin/stats" element={<AdminStatsPage />} />
          <Route path="/admin/reconcile" element={<AdminReconcilePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
